import { useEffect, useState } from 'react';

import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'common-ui/button';
import MyRadioGroup from 'common-ui/radioGroup';
import { Select } from 'common-ui/select';
import {
  getWorkflowStatusesByPrivilege,
  nextLeadStep,
  updateLeadStatus,
} from 'features/sales/salesActions';
import { selectWorkflowStatusesByPrivilege, setResetAll } from 'features/sales/salesSlice';
import { generateOptions } from 'utils';

import {
  ChangeStatusDiv,
  Div,
  FilterActions,
  FilterContainer,
  NextStatus,
  NextStatusWrapper,
  SearchButtonWrapper,
  StatusDiv,
} from './Filter.styles';

const Filter = ({ status, leadId, currentStatus }) => {
  const navigate = useNavigate();
  const [option, setOption] = useState('random');
  const {
    control,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(),
    shouldFocusError: false,
  });
  const dispatch = useDispatch();
  const workflowStatusesByPrivilege = useSelector(selectWorkflowStatusesByPrivilege);
  const selectedStatus = watch('status');
  const handleChange = () => {
    dispatch(
      nextLeadStep({
        leadId: leadId,
        data: {
          option: option,
          currentStatusId: selectedStatus?.value,
        },
      })
    )
      .unwrap()
      .then((nextLead) => {
        if (nextLead.leadId) {
          dispatch(setResetAll());
          navigate(`/leads/${nextLead.leadId}`, { replace: true });
        } else {
          navigate(-1);
        }
      });
  };

  const handleChangeStatus = (data) => {
    dispatch(
      updateLeadStatus({
        leadId: leadId,
        data: {
          newStatusId: data.value,
          comment: 'Moved to contacted',
        },
      })
    );
    handleChange();
  };

  const handleChangeOption = (e) => {
    setOption(e.target.value);
  };

  useEffect(() => {
    dispatch(getWorkflowStatusesByPrivilege());
  }, [dispatch, leadId]);

  useEffect(() => {
    if (!selectedStatus) {
      if (currentStatus) {
        reset({
          status: {
            label: currentStatus.name,
            value: currentStatus.uuid,
          },
        });
      } else {
        reset({
          status: null,
        });
      }
    }
  }, [currentStatus, reset]);

  return (
    <FilterContainer>
      <FilterActions>
        <Div>
          <MyRadioGroup
            value={option}
            options={[
              { label: 'Random', value: 'random' },
              { label: 'Ascending', value: 'ascending' },
              { label: 'Descending', value: 'descending' },
            ]}
            onChange={handleChangeOption}
            row={true}
          />
        </Div>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <StatusDiv>
              <Select
                {...field}
                label="‎"
                $error={errors.branchHeadId?.message}
                options={generateOptions(workflowStatusesByPrivilege?.items)}
                placeholder="Status"
                maxMenuHeight={180}
              />
            </StatusDiv>
          )}
        />
        <SearchButtonWrapper>
          <Button onClick={() => handleChange()} width="90px" height="38px" secondary>
            Search Lead
          </Button>
        </SearchButtonWrapper>
      </FilterActions>
      <NextStatusWrapper>
        <Controller
          name="nextStatus"
          control={control}
          render={({ field }) => {
            return (
              <ChangeStatusDiv>
                <Select
                  {...field}
                  label="‎"
                  $error={errors.branchHeadId?.message}
                  value=""
                  isWhiteArrow={true}
                  options={generateOptions(status?.filter((item) => item.changeable))}
                  styles={NextStatus}
                  placeholder="Next status"
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption);
                    handleChangeStatus(selectedOption);
                  }}
                />
              </ChangeStatusDiv>
            );
          }}
        />
      </NextStatusWrapper>
    </FilterContainer>
  );
};

export default Filter;
